const mEditionBillingAcademySales = {
  mEditionBillingAcademySales: {
    alerts: {
      readVentasExportar: {
        error: 'Un error ha ocurrido. Espera un momento y vuelve a intentarlo.',
        success: 'Listado de ventas descargado.'
      },

      readVentas: {
        error: 'La academia que busca con ese url no existe'
      }
    },

    buttonPrimary: 'Descargar CSV',

    buttonSecondary: {
      filterText: 'Filtros Avanzados'
    },

    files: {
      sales: 'ventas'
    },

    free: 'Gratis',

    table: {
      thConcept: 'Detalle',
      thClient: 'Alumno',
      thDate: 'Fecha',
      thDiscount: 'Desc.',
      thMethod: 'Medio',
      thRecord: 'Ver',
      thToPay: 'A Pagar',
      thTotal: 'Total'
    },

    tooltip: {
      restart: 'Actualizar'
    }
  }
}

export default mEditionBillingAcademySales
